<template>
  <b-container>
    <div class="wrapper">
      <!-- pin : {{ pin }} -->
      <!-- {{ mapOptions }} -->
      <bing-map :credentials="apiKey" :options="mapOptions">
        <bing-map-layer>
          <bing-map-pushpin :location="pin.location" :visible="true">
          </bing-map-pushpin>
        </bing-map-layer>
      </bing-map>
    </div>
  </b-container>
</template>
<script>
import Vue from "vue";
import VueBingMaps from "vue-bing-maps";
Vue.use(VueBingMaps);
Vue.use(VueBingMaps, { debug: true });
export default {
  name: "BaseMap",
  props: {
    apiKey: String,
    pin: Object,
  },
  created() {},
  data() {
    return {
      mapOptions: {
        center: {
          latitude: this.pin.location.latitude,
          longitude: this.pin.location.longitude,
        },
        zoom: 17,
      },
    };
  },
  computed: {},
  methods: {},
  
};
</script>
<style scoped>
.wrapper{
  width: 100%;
  height: 400px;
}
</style>
